import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getRevision: async ({ commit }, payload) => {
    try {
      const { documentId, ...params } = payload;
      const res = await axios.get(
        `/documents/${documentId}/revision`,
        {
          params
        }
      );

      commit('mutateRevisionDocument', res.data);
      return res;
    } catch (err) {
      return err;
    }
  },

  getDocuments: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`/documents`, {
        params: {
          ...payload
        }
      });

      commit('mutateDocumentsByKind', res.data);
      return res;
    } catch (error) {
      return error.response;
    }
  },

  getDocumentById: async ({ commit }, payload) => {
    try {
      commit('mutateDocumentError', '');
      const { documentId, triggerSharedEvent } = payload;

      const res = await axios.get(
        `/documents/${documentId}`,
        {
          params: {
            triggerSharedEvent: triggerSharedEvent === true
          }
        }
      );
      commit('mutateDocumentById', res.data);
      return res;
    } catch (error) {
      commit('mutateDocumentError', 'Cannot find showcase');
      return error.response;
    }
  },

  setDocumentById: ({ commit }, payload) => {
    commit('mutateDocumentById', payload);
    return;
  },

  createDocument: async (_, payload) => {
    try {
      const res = await axios.post(`/documents`, payload);
      return res;
    } catch (err) {
      return err.response;
    }
  },

  updateDocument: async (_, payload) => {
    try {
      const { documentId, document, ...theRest } = payload;
      const res = await axios.put(
        `/documents/${documentId}`,
        {
          document: { ...document },
          ...theRest
        }
      );

      return res;
    } catch (err) {
      return err.response;
    }
  },

  updateDocumentCreativity: async ({ commit }, payload) => {
    try {
      const { documentId, ...params } = payload;
      await axios.put(
        `/documents/${documentId}/update-creativity`,
        null,
        {
          params
        }
      );
    } catch (err) {
      commit(
        'mutateDocumentCreativityError',
        'There was an error updating document to creativity'
      );
      return err.response;
    }
  },

  updateDocumentStatus: async ({ commit }, payload) => {
    try {
      const { documentId, ...theRest } = payload;

      const res = await axios.post(
        `/documents/${documentId}/change-status`,
        null,
        {
          params: {
            ...theRest
          }
        }
      );
      commit('mutateDocumentError', '');
      return res;
    } catch (error) {
      commit(
        'mutateDocumentError',
        'There was a problem updating the document status'
      );
      return error.response;
    }
  },

  deleteDocument: async (_, payload) => {
    try {
      const { documentId } = payload;
      const res = await axios.delete(
        `/documents/${documentId}`
      );
      return res;
    } catch (error) {
      return error.response;
    }
  },

  setDocumentToPreview: async ({ commit }, payload) => {
    commit('mutateDocumentToPreview', payload);
  },

  getDocumentItineraries: async ({ commit }, payload) => {
    try {
      const { documentId, ...params } = payload;
      const res = await axios.get(
        `/documents/${documentId}/itineraries/linked`,
        {
          params: { ...params }
        }
      );
      commit('mutateDocumentItineraries', res.data);
      return res;
    } catch (error) {
      return error.response;
    }
  },

  getDocumentsForDebounceSearch: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`/documents`, {
        params: {
          ...payload
        }
      });

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  resetDocumentsState: async ({ commit }) => {
    commit('resetState');
  },

  documentApproval: async (_, payload) => {
    const { documentId, status, cause } = payload;

    try {
      const res = await axios.post(
        `/documents/${documentId}/document-approval`,
        { cause },
        {
          params: {
            status: status
          }
        }
      );
      return res;
    } catch (err) {
      return err.response;
    }
  }
};

export const mutations = {
  resetState: state => {
    Object.assign(state, initialState());
  },

  mutateDocumentsByKind: (state, payload) => {
    state.documents = payload;
  },

  mutateDocumentCreativityError: (state, payload) => {
    state.documentCreativityError = payload;
  },

  mutateDocumentById: (state, payload) => {
    state.documentById = payload;
  },

  mutateDocumentToPreview: (state, payload) => {
    state.documentToPreview = payload;
  },

  mutateDocumentItineraries: (state, payload) => {
    state.documentItineraries = payload;
  },

  mutateDocumentError: (state, payload) => {
    state.documentErrorMsg = payload;
  },
  mutateRevisionDocument: (state, payload) => {
    state.revisionDocument = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    documents: [],
    documentById: {},
    documentToPreview: {},
    documentToPreviewProjectId: '',
    documentItineraries: {},
    documentErrorMsg: '',
    revisionDocument: {
      revision: null
    },
    documentCreativityError: ''
  };
}
